import useUserCourses from '../use-user-courses'
import useCurrentUser from '../use-current-user'
import useSchoolYear from '../use-school-year'

const useUserYearCourses = ({
    date,
    userId
} = {}) => {
    const { id: currentUserId } = useCurrentUser()
    const { getOffset } = useSchoolYear()
    const { startDate, endDate } = useSchoolYear({ offset: getOffset(date) })
    const { courses, isLoading } = useUserCourses({
        userId: userId || currentUserId,
        startDate,
        endDate,
    })

    return {
        isLoading,
        courses,
    }
}

export default useUserYearCourses